[
  {
    "identifyExtra": "extra"
  },
  {
    "name": "Vulcan | CartoPay",
    "identify": "etna",
    "urlApi": "http://dc1vrt548.connectsa.br/connectpack/app/VULCAN",
    "applicationCode": "6b4a636a595597de57b525a11a5fee58",
    "logo_empresa": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "logo_empresa_light": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "logo_empresa_dark": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "logo_empresa_small_light": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "logo_empresa_small_dark": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "favicon": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg8cezqyPw5gvrhqL8J-b8RTQmccRrv4IJbQ&s",
    "cover_login": "https://cdn-vulcan-us.s3.us-east-1.amazonaws.com/cartopay-stage/cover_login.png",
    "url_facebook": "",
    "url_instagram": "",
    "url_linkedin": "",
    "gTagManager": "G-EP530J7CNM",
    "idHOTJAR": "3532604",
    "appVersion": "1.0.0",
    "primaryColor": "#f2b72e",
    "secondaryColor": "#56e895",
    "tertiaryColor": "#343a40",
    "quaternaryColor": "#f8f9fa",
    "successColor": "#28a745",
    "infoColor": "#17a2b8",
    "warningColor": "#ffc107",
    "dangerColor": "#dc3545",
    "ambient": "H"
  }
]
